import React, { Component } from "react";
import MetaTags from 'react-meta-tags';
import { translate } from "react-i18next";
import Footer from "../layout/footer";

class Awards extends Component {
    state = {
    }
    goToAwardProgram = () => {
        var d = document.getElementById("awardProgram");
        var topPos = d.offsetTop;
        var header = document.getElementById("nav");
        let headerHeight = header.offsetHeight;

        window.scrollTo({
            top: (topPos - headerHeight),
            left: 0,
            behavior: "smooth"
        });
    }
    updateVideo(type) {
        let videoSrc;
        if (type === 'session_1') {
            videoSrc = 'https://storage.googleapis.com/emsd_video/Welcome%20%26%20Opening%20Speeches.mp4';
        } else if (type === 'session_2') {
            videoSrc = 'https://storage.googleapis.com/emsd_video/Launching%20Ceremony%20of%20E%26M%20AI%20Lab.mp4';
        }

        let video = document.getElementById('video');

        video.setAttribute('src', videoSrc + "?autoPlay=1&amp;modestbranding=1&amp;showinfo=0");
    }
    componentDidMount() {
        let myModal = document.getElementById('myModal');
        let video = document.getElementById('video');

        myModal.addEventListener('hide.bs.modal', function () {
            video.setAttribute('src', '');
        });

        var path = window.location.pathname
        path = path.slice(1, 3);
        if (path === 'en') {
          require("./award.css");
        } else if (path === 'sc') {
          require("./award_sc.css");
        } else if (path === 'tc') {
          require("./award_tc.css");
        }
    }
    componentWillUnmount() {
        let myModal = document.getElementById('myModal');
        let video = document.getElementById('video');

        myModal.removeEventListener('hide.bs.modal', function () {
            video.setAttribute('src', '');
        });
        this.setState=()=>false;
    }
    render() {
        const { t } = this.props;
        return (
            <div className="d-flex justify-content-center">
                <MetaTags>
                    <title>{t('award-meta-title')}</title>
                    <meta name="title" content={t('award-meta-title')} />
                    <meta name="description" content={t('award-meta-description')} />
                    <meta name="keywords" content={t('award-meta-keywords')} />
                </MetaTags>
                <div id="div-award">
                    <div className="award-banner">
                        <div className="container-fluid d-flex justify-content-center align-items-center">
                            <div>
                                <div className={t('award-banner-headline-1 text-center TXT_medium')}>{t('award-banner-headline-1')}</div>
                                <div className={t('award-banner-headline-2 text-center TXT_medium')}>{t('award-banner-headline-2')}</div>
                                <div className={t('award-banner-headline-3 text-center TXT_normal_medium')}>{t('award-banner-headline-3-1')}<br className="d-md-none" />{t('award-banner-headline-3-2')}</div>
                                <div className={t('award-banner-headline-4 text-center TXT_bold')}>{t('award-banner-headline-4')}</div>
                                <div className="d-flex justify-content-center">
                                    <a className="no_border" onClick={() => this.goToAwardProgram()}><button className={t('btn_watchAwards TXT_medium')}>{t('Watch the Awards Ceremony Replay')}</button></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="awardProgram">
                        <div className="container-fluid d-flex justify-content-center div-award-intro">
                            <div className="col-12 col-lg-10">
                                <div className="award-intro-text"><span className={t('TXT_bold')}>{t('award-intro-text-1')}</span><span>{t('award-intro-text-2')}</span></div>
                            </div>
                        </div>

                        <div className={t('award-rundown-headline text-center TXT_medium')}>{t('award-rundown-headline')}</div>

                        <div className="award-rundown-detail">
                            <div className="container-fluid">
                            <div className="div-award-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className={t('award-rundown-detail-prorgram-time-xl text-end TXT_bold')}>{t('award-rundown-detail-prorgram-time-1')}</div>
                                    <div className="award-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="award-rundown-detail-program-break-light-xl"></div>
                                            <div className="award-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="award-rundown-detail-program-info">
                                        <div>
                                            <div className={t('award-rundown-detail-prorgram-info-title TXT_bold')}>{t('award-rundown-detail-prorgram-title-1')}</div>
                                            <div className={t('award-rundown-detail-prorgram-replay TXT_bold d-flex align-self-center')} data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('session_1')}><span>{t('conf-rundown-detail-prorgram-text-replay')}</span><div className="replay-icon"></div></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="div-award-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className={t('award-rundown-detail-prorgram-time-xl text-end TXT_bold')}>{t('award-rundown-detail-prorgram-time-2')}</div>
                                    <div className="award-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="award-rundown-detail-program-break-light-xl"></div>
                                            <div className="award-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="award-rundown-detail-program-info">
                                        <div>
                                            <div className={t('award-rundown-detail-prorgram-info-title TXT_bold')}>{t('award-rundown-detail-prorgram-title-2')}</div>
                                            <div className={t('award-rundown-detail-prorgram-replay TXT_bold d-flex align-self-center')} data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('session_2')}><span>{t('conf-rundown-detail-prorgram-text-replay')}</span><div className="replay-icon"></div></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="div-award-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className={t('award-rundown-detail-prorgram-time-xl text-end TXT_bold')}>{t('award-rundown-detail-prorgram-time-3')}</div>
                                    <div className="award-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="award-rundown-detail-program-break-light-xl"></div>
                                            <div className="award-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="award-rundown-detail-program-info">
                                        <div>
                                            <div className={t('award-rundown-detail-prorgram-info-title TXT_bold')}>{t('award-rundown-detail-prorgram-title-3-1')}</div>
                                            <div className={t('award-rundown-detail-prorgram-info-title TXT_bold')}>{t('award-rundown-detail-prorgram-title-3-2')}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="div-award-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className={t('award-rundown-detail-prorgram-time-xl text-end TXT_bold')}>{t('award-rundown-detail-prorgram-time-4')}</div>
                                    <div className="award-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="award-rundown-detail-program-break-light-xl"></div>
                                            <div className="award-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="award-rundown-detail-program-info">
                                        <div>
                                            <div className={t('award-rundown-detail-prorgram-info-title TXT_bold')}>{t('award-rundown-detail-prorgram-title-4')}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="div-award-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className={t('award-rundown-detail-prorgram-time-xl text-end TXT_bold')}>{t('award-rundown-detail-prorgram-time-5')}</div>
                                    <div className="award-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="award-rundown-detail-program-break-light-xl"></div>
                                            <div className="award-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="award-rundown-detail-program-info">
                                        <div>
                                            <div className={t('award-rundown-detail-prorgram-info-title TXT_bold')}>{t('award-rundown-detail-prorgram-title-5')}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="div-award-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className={t('award-rundown-detail-prorgram-time-xl text-end TXT_bold')}>{t('award-rundown-detail-prorgram-time-6')}</div>
                                    <div className="award-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="award-rundown-detail-program-break-light-xl"></div>
                                            <div className="award-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="award-rundown-detail-program-info">
                                        <div>
                                            <div className={t('award-rundown-detail-prorgram-info-title TXT_bold')}>{t('award-rundown-detail-prorgram-title-6')}</div>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
                {/*  Modal */}
                <div className="modal fade" id="myModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-body">
                                <div className="d-flex justify-content-end">
                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>

                                <div className="ratio ratio-16x9">
                                    <video autoPlay playsInline controls src="" id="video">
                                        <source src="" type="video/mp4"/>
                                    </video>
                                    {/* <iframe className="embed-responsive-item" src="" id="video" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" title="Video"></iframe> */}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div >



        );
    }
}

// extended main view with translate hoc
export default translate("translations")(Awards);



// WEBPACK FOOTER //
// ./src/components/pages/award.js